import { Box, Group, Skeleton, Stack } from '@mantine/core';

export default function AvailabilityProviderCardSkeleton() {
  return (
    <Stack gap={0}>
      {/* Provider Header */}
      <Box
        p="xs"
        style={{
          borderBottom: '1px solid #e9ecef',
        }}
      >
        <Group gap="md">
          <Skeleton height={36} width={36} radius="xl" />
          <Skeleton height={18} width={120} />
        </Group>
      </Box>

      {/* Availability Entries */}
      <Box p="lg">
        <Stack gap={0}>
          {[1, 2, 3].map((idx) => (
            <Box
              key={idx}
              py={12}
              style={{
                borderBottom: idx < 3 ? '1px solid #e0e0e0' : 'none',
              }}
            >
              <Group gap="md" align="flex-start" wrap="nowrap">
                <Stack gap={4} style={{ minWidth: '140px', alignItems: 'flex-start' }}>
                  <Skeleton height={24} width={80} radius="xl" />
                </Stack>
                <Stack gap={4} style={{ flex: 1 }}>
                  <Skeleton height={14} width={60} />
                  <Skeleton height={14} width={180} />
                </Stack>
              </Group>
            </Box>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
